import DarkModeButton from "../DarkModeButton/DarkModeButton";
import { Header } from "./NewHeader.style";

export default function NewHeader() {
  return (
    <Header>
      <DarkModeButton/>
    </Header>
  )
}
